import { useState } from "react";

export function useToggleModalWithLocalState(initialState = false) {
    const [isModalOpen, setIsModalOpen] = useState(initialState);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };

    const toggleModal = () => {
        setIsModalOpen((prevState) => !prevState);
    };

    return {
        isModalOpen,
        openModal,
        closeModal,
        toggleModal,
    };
}

export default useToggleModalWithLocalState;
